export const environment = {
  verboseLogging: true,
  production: false,
  signInAllowed: true,
  auth: {
    clientId: 'dev-webapp',
    authority: 'https://auth.fsmb.rwth-aachen.de/realms/unicup',
    redirectUri: 'https://kvv-pos-uat.unicup.rwth-aachen.de/loginRedirect',
  },
  api: {
    backendBaseUrl: 'https://uat.unicup.rwth-aachen.de/api',
    pushMonkeyBaseUrl: 'https://uat.unicup.rwth-aachen.de/push',
  },
};
